export default Object.freeze({
  GenericHttps: 1,
  SplunkHec: 2,
  EventHub: 3,
});
